import { Iconify } from '@sohanemon/utils/components';
import { useIsLightTheme } from '@sohanscript/theme/store';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
	const isLight = useIsLightTheme();
	const sonnerTheme = isLight ? 'light' : 'dark';
	return (
		<Sonner
			theme={sonnerTheme}
			className="toaster group"
			style={
				{
					'--normal-bg': 'var(--card)',
					'--normal-text': 'var(--card-foreground)',
					'--normal-border': 'var(--border)',
					'--border-radius': 'var(--radius)',
				} as React.CSSProperties
			}
			icons={{
				success: <Iconify icon="lucide:circle-check" className="size-5" />,
				info: <Iconify icon="lucide:triangle-alert" className="size-5" />,
				warning: <Iconify icon="lucide:triangle-alert" className="size-5" />,
				error: <Iconify icon="lucide:octagon-x" className="size-5" />,
				loading: (
					<Iconify icon="lucide:loader-2" className="size-5 animate-spin" />
				),
			}}
			toastOptions={{
				style: { zIndex: '9999 !important' },
				classNames: {
					toast: 'toast group',
					closeButton:
						'left-auto! hover:scale-120 scale-110 -end-4! transition-[scale]',
				},
			}}
			{...props}
		/>
	);
};

export { Toaster };
